"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var lodash_1 = __importDefault(require("lodash"));
var moment_1 = __importDefault(require("moment"));
var types_1 = __importDefault(require("../types"));
var createLastMessage_1 = __importDefault(require("./helpers/createLastMessage"));
var processMessage_1 = __importDefault(require("./helpers/processMessage"));
function chatRoomMessagesReducer(state, action) {
    var _a, _b;
    switch (action.type) {
        case types_1["default"].SET_MESSAGES: {
            var _c = action.payload, roomId = _c.roomId, messages = _c.messages, isReplace = _c.isReplace;
            if (messages && !lodash_1["default"].isArray(messages))
                messages = [messages];
            var currentState = ((_a = state.rooms[roomId]) === null || _a === void 0 ? void 0 : _a.messages) || [];
            var currentMessages_1 = isReplace ? [] : currentState.asMutable({ deep: true });
            messages.forEach(function (message) {
                var index = lodash_1["default"].findIndex(currentMessages_1, { _id: message._id });
                var chatMessage = processMessage_1["default"](message);
                if (index !== -1)
                    currentMessages_1[index] = chatMessage;
                else
                    currentMessages_1.push(chatMessage);
            });
            var sortedMessages = lodash_1["default"].orderBy(currentMessages_1, 'ts');
            for (var i = 0; i < sortedMessages.length; i++) {
                var item = sortedMessages[i];
                var prevItem = sortedMessages[i - 1] || {};
                item.ts_date_different = item.ts_date_formatted !== prevItem.ts_date_formatted;
                var userId = lodash_1["default"].get(item, 'u._id');
                var isSomeUser = userId === lodash_1["default"].get(prevItem, 'u._id');
                item.is_sequence = isSomeUser;
                item.is_sequence_start = !isSomeUser;
                var nextItem = sortedMessages[i + 1] || {};
                item.is_sequence_end = userId !== lodash_1["default"].get(nextItem, 'u._id');
            }
            return state.setIn(['rooms', roomId, 'messages'], sortedMessages);
        }
        case types_1["default"].MESSAGE_RECEIVED: {
            var message = action.payload;
            var roomId = message.rid;
            var isMe_1 = ((_b = state.me) === null || _b === void 0 ? void 0 : _b._id) === message.u._id;
            state = state.updateIn(['rooms', roomId, 'unread'], function (val) {
                if (val === void 0) { val = 0; }
                return (isMe_1 ? 0 : val + 1);
            });
            state = state.setIn(['rooms', roomId, 'lastMessage'], createLastMessage_1["default"](message));
            state = state.setIn(['rooms', roomId, 'updatedAt'], moment_1["default"]().toISOString());
            return state;
        }
        default:
            return state;
    }
}
exports["default"] = chatRoomMessagesReducer;
